// src/ble/DeviceMenu.js
import React from 'react';
import { NavLink } from 'react-router';
import './DeviceMenu.css';

const DeviceMenu = () => {
  return (
    <nav className="device-menu">
      {/* <NavLink to="/device" end className={({ isActive }) => (isActive ? 'active' : '')}>
        🧭 Device Config
      </NavLink> 
      <NavLink to="/device/map" className={({ isActive }) => (isActive ? 'active' : '')}>
        📍 Static Map
      </NavLink><NavLink to="/device/events" className={({ isActive }) => (isActive ? 'active' : '')}>
        📅 Playa Events
      </NavLink>
      
      */}
      <NavLink to="/device/" end className={({ isActive }) => (isActive ? 'active' : '')}>
        🧭 Compass Config
      </NavLink>
      <NavLink to="/device/compass-map" className={({ isActive }) => (isActive ? 'active' : '')}>
        📍 Static Map
      </NavLink>
      <NavLink to="/device/compass-events" className={({ isActive }) => (isActive ? 'active' : '')}>
        📅 Playa Events
      </NavLink>
      <NavLink to="/device/protobuf" className={({ isActive }) => (isActive ? 'active' : '')}>
        🔦 Protobuf Device
      </NavLink>
    </nav>
  );
};

export default DeviceMenu;
